import { isFalsyString } from '@surglogs/util'

import { AuthContextStore } from './AuthContextStore'
import { getUserIdKey } from './helpers/storageKeys'

const getValidatedValue = <T extends string = any>(
  value: T | null,
): T | null => {
  if (isFalsyString(value)) {
    return null
  }

  return value
}

export class AuthContextStorage {
  constructor(
    private storage: Storage,
    private contextStore: AuthContextStore,
    private legacyStorage?: Storage,
  ) {
    this.migrateFromLegacyStorage()

    this.contextStore.onChange(({ userId }) => {
      if (userId) {
        this.storage.setItem(getUserIdKey(), String(userId))
      }
    })
  }

  clear() {
    this.storage.removeItem(getUserIdKey())
    this.legacyStorage?.removeItem(getUserIdKey())

    return this
  }

  sync() {
    const userId = this.getUserId()
    if (userId) {
      this.contextStore.setUserId(userId)
    } else {
      this.contextStore.clearUserId()
    }

    return this
  }

  private getUserId() {
    return getValidatedValue(this.storage.getItem(getUserIdKey()))
  }

  private migrateFromLegacyStorage() {
    if (!this.legacyStorage) return

    const key = getUserIdKey()
    const currentValue = this.storage.getItem(key)

    if (!currentValue) {
      const legacyValue = this.legacyStorage.getItem(key)

      if (legacyValue) {
        this.storage.setItem(key, legacyValue)
        this.legacyStorage.removeItem(key)
      }
    }
  }
}
